import Typography from "@mui/material/Typography";
import FileInput from "./FileInput";
import type { FileInputProps } from "./types";

const ProofFileInput = <TFormField extends string>(props: FileInputProps<TFormField>) => (
    <FileInput<TFormField>
        accept={{
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg', '.jpg'],
            'application/pdf': ['.pdf'],
            'application/vnd.ms-excel': ['.xls', '.xlsx']
        }}
        {...props}
        placeholderProps={{
            sx: {
                opacity: 1
            },
            titleSlot: (
                <Typography
                    variant='subtitle2'
                >
                    Drop or Select a file (PNG, JPEG, PDF, XLS)
                </Typography>
            ),
            subtitleSlot: <></>,
            ...props.placeholderProps
        }}
    />
);

export default ProofFileInput;
